window.addEventListener("load", function () {
    const clickouts = document.querySelectorAll('.clickout[data-clickout]');

    if( clickouts.length ) {
        clickouts.forEach(function(element) {
            let clickout = new ShowHideClickout(element);
        });
    }
});
